module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// C:/GH/1106/advice.noa.origination/~/prop-types/lib/has.js
// module id = 202
// module chunks = 0